import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TellentPosition } from '@core/tellent-positions-types';

@Component({
  selector: 'tlc-position-details-description',
  template: `description`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionDetailsDescriptionComponent {
  public readonly positionData = input.required<TellentPosition | null>();
}
